<template>
    <div>
        <div class="card shadow p-0">
           <div class="container">
                <div class="row pt-4">
                        <div class="col-2">
                            <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a>
                        </div>
                        <div class="col-10 card-title">
                            <router-link id="disabled-wrapper"  :to="{ name: 'SouscripteurDashboard' }">
                                {{ $t('message.addPatient') }}
                                <i class="fas fa-plus-circle edit-icon"></i>
                            </router-link>
                            <b-tooltip ref="tooltip" target="disabled-wrapper"> {{$t('message.addAffilies')}}</b-tooltip>
                        </div>
                </div>
            </div>    
                <b-container>
            <b-row class="p-0">
                 <b-col col sm="12" class="justify-content-center">
                    
                <!--<div class="row card-title pt-4">
                     <div class="col-sm-3 col-xs-3">
                          
                     <button 
                        type="button"    
                        @click="hasHistory() 
                            ? $router.go(-1) 
                            : $router.push('/')" class="btn btn-secondary btn-sm">&laquo; 
                            {{$t('message.backtap')}}
                    </button> -->
                    <!-- </div> -->
                   
                   
                <!-- </div> -->

                <!-- </b-col>
                <b-col> -->
                      <template v-if="rows">
                        <h4 class="card-title text-center mb-2 mt-2 title">{{$t('message.listOfAffilaites')}}</h4>
                        <p class="text-center">{{$t('message.clickaffiliate')}}</p>
                        <div v-if="!mobileView">
                            <vue-good-table
                                    id="affiliate"
                                    v-if="mAffiliate.length >0"
                                    :columns="affiliateColumns"
                                    :rows="mAffiliate"
                                    :search-options="enabled"
                                    :pagination-options="paginationOptions"
                                    @on-cell-click="onaffiliateRowClick"
                                >
                                <template slot="table-row" slot-scope="props">
                                    <a href="#" v-if="props.column.field == 'actions'" @click="onaffiliateRowClick(props)">
                                     <i class="fas fa-eye"></i>{{$t('message.detailAffiliation')}}
                                    </a>
                                </template>
                            </vue-good-table>
                        </div>
                        <div id="table-demo" v-else> 
                            <div class="ltemp--content--box border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white affiliate_border" v-for="(row, x) in mAffiliate" :key="x" @click="onaffiliateRowClickMobile(row.slug)"> <!-- v-for="(row, x) in medecinesRows" :key="x"  @click="onMedecineRowClickMobile(row.slug)" -->
                                <div class="trajet__info bg-white mt-2 px-2" > 
                                    <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                        <span class="d-flex align-items-center text-gray">
                                            <span class="px-1"> {{row.produit}} </span>
                                        </span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default text-gray"> {{row.nom}} </span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.email}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.qualite}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.date_fin}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.status_contrat}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="">
                                            <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onaffiliateRowClickMobile(row.slug)"> <!-- @click="onaffiliateRowClickMobile(row.slug) "-->
                                                <span class="d-none d-md-block">Voir</span>
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </b-button> 
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                            
                    </template>

                    <template v-else>
                        <div class="card">
                            <div class="card-body text-xs-center">
                                <p class="card-text">
                                    {{ $t('message.nothing') }}
                                </p>
                            </div>
                        </div>
                    </template>
                    <template v-if="rows">
                        <h3 class="card-title text-center mb-2 mt-2 title">{{$t('message.listOfAffilaitesOld')}}</h3>
                        <p class="text-center">{{$t('message.clickaffiliate')}}</p>
                        <div v-if="!mobileView">
                            <vue-good-table
                                id="patient"
                                v-if="mPatient.length >0"
                                :columns="patientColumns"
                                :rows="mPatient"
                                :search-options="enabled"
                                :pagination-options="paginationOptions"
                                @on-cell-click="onPaitientRowClick"
                                >
                                <template slot="table-row" slot-scope="props">
                                    <a href="#" v-if="props.column.field == 'actions'" @click="onPaitientRowClick(props)">
                                        <i class="fas fa-eye"></i> {{$t('message.detailAffiliation')}}
                                    </a>
                                </template>
                            </vue-good-table>
                        </div>
                        <div id="table-demo" v-else> <!-- v-if="mobileView" -->
                            <div class="ltemp--content--box border-1 px-2 px-md-4 py-2 my-2 mx-md-3 rounded bg-white affiliate_border" v-for="(row, x) in mPatient" :key="x" @click="onPaitientRowClickMobile(row)"> <!-- v-for="(row, x) in medecinesRows" :key="x"  @click="onMedecineRowClickMobile(row.slug)" -->
                                <div class="trajet__info bg-white mt-2 px-2" > 
                                    <div class="trajet__info--text h-100 d-flex align-items-center justify-content-between fs-6">
                                        <span class="d-flex align-items-center text-gray">
                                            <span class="px-1"> {{row.produit}} </span>
                                        </span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default text-gray"> {{row.nom}} </span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.email}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.qualite}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="text-default d-none text-gray d-md-block">{{row.status_contrat}}</span>
                                        <span class="d-none d-md-block"><i class="fa fa-minus" aria-hidden="true"></i></span>
                                        <span class="">
                                            <b-button class="border-0 p-0 d-flex align-items-center shadow-none bg-transparent text-primary" @click="onPaitientRowClickMobile(row.slug)">
                                                <span class="d-none d-md-block">Voir</span>
                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                            </b-button> 
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="card">
                            <div class="card-body text-xs-center">
                                <p class="card-text">
                                   {{ $t('message.nooldpatient') }}
                                </p>
                            </div>
                        </div>
                    </template>
                </b-col>
            </b-row>
        </b-container>
          
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
        import SlimSelect from 'slim-select';
    import moment from "moment";
    import { required, email,integer, minLength } from 'vuelidate/lib/validators';
    export default {
        name: "SouscripteurDashboard",

        computed: {
            ...mapGetters(["subscriber", 'hasAdminRole', "countries", "patients",
                'hasGestionnaireRole','hasSouscripteurRole','hasMedecinControleRole','hasPraticienRole',
                "affiliations","commandes"]),

            mSubscriber: function() {
                   /* if(this.subscriber.affiliation[0].nombre_restant > 1){
                      this.$router.push({ name: 'add-patient-souscripteur'});
                    }*/
                //this.subscriber_id = this.subscriber.id;
                return this.subscriber;
            },
            form:function() {
                return this.subscriber;
            },
            mCommandes: function (){
                let restant = [];
                if( !_.isUndefined(this.commandes) && !_.isNull(this.commandes)){
                  restant = this.commandes;
                }

                return restant;
            },
            mCountries: function() {
                let cArray = [];

                _.forOwn(this.countries, function(value, key) {
                    cArray.push({ text: value.name, value: value.name });
                });

                return cArray;
            },
            mAffiliate:function(){
                let pArray = [];
                // console.log('subscriber ', this.subscriber.patients)
                // console.log('subscriber ', this.affiliations)
                _.forEach(this.affiliations, function(affiliation) {
                    let p = {};
                    p.produit = affiliation.package.description_fr != null ? affiliation.package.description_fr : "CIM";
                    p.nom = (affiliation.patient.user.prenom ? affiliation.patient.user.prenom : '') + "  " + (affiliation.patient.user.nom ? (affiliation.patient.user.nom).toUpperCase() : '') ;
                    p.dossier = affiliation.patient.dossier ? affiliation.patient.dossier.numero_dossier : '';
                    p.dossierSlug = affiliation.patient.dossier ? affiliation.patient.dossier.slug : '';
                    p.email = affiliation.patient.user.email;
                    p.telephone = affiliation.patient.telephone;
                    p.age = affiliation.patient.age;
                    p.nationalite = affiliation.patient.nationalite;
                    p.ville = affiliation.patient.ville;
                    p.pays = affiliation.patient.pays;
                    p.date = moment(affiliation.patient.date_de_naissance).format('DD-MM-YYYY');
                    p.id = affiliation.patient.id;
                    p.qualite = affiliation.patient.financeurs[0] == undefined ? 'Autres': (affiliation.patient.financeurs[0].lien != null ? affiliation.patient.financeurs[0].lien.fr_description : 'Autres');
                    p.date_debut = affiliation.date_debut;
                    p.date_fin = affiliation.date_fin;
                    p.slug = affiliation.slug;
                    p.adresse = affiliation.patient.adresse;
                    p.status_contrat = affiliation.status_contrat;
                   
                    
                    pArray.push(p);
                });
                return pArray;
            },

            mPatient:function(){
                let mArray = [];
                // console.log('subscriber ', this.subscriber.patients)
                _.forEach(this.subscriber.patients, function(patient) {
                    if(patient != null){
                        const dateIsAfter = moment(patient.created_at).isAfter(moment('2021-12-31 00:00:00'));
                        // si c'est true, on est dans une ancienne affiliation
                        if(!dateIsAfter){
                            let m = {};
                            m.produit =  "CIM";
                            m.nom = patient.user.prenom + ' ' + patient.user.nom;
                            m.dossier = patient.dossier.numero_dossier;
                            m.dossierSlug = patient.user;
                            m.email = patient.user.email ? patient.user.email : '';
                            m.telephone = patient.user;
                            m.age = patient.date_de_naissance;
                            m.nationalite = patient.user.nationalite;
                            m.ville = patient.user.ville;
                            m.pays = patient.user.pays;
                            m.date = patient.user.date_de_naissance;
                            m.id = patient.user.id;
                            m.slug = patient.user.slug;
                            m.adresse = patient.user.adresse;
                            m.status_contrat = 'Généré';
                            mArray.push(m);
                        }
                    }
                    
                });
                return mArray;
            },

            mSubscriberUserInformation:function(){
                return this.mSubscriber.patient;
            },

            fullName:function () {
                let prenom  = this.mSubscriberUserInformation.prenom != null ? this.mSubscriberUserInformation.prenom : "";
                return this.getValue(prenom) + "  " + (this.getValue(this.mSubscriberUserInformation.nom)).toUpperCase();

            },

            rows: function() {
                if(typeof  this.mSubscriber.patients == "object")
                    return this.mSubscriber.patients.length;
                return 0;
            },

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

        },

        data() {
            return {
                mobileView: true,
                subscriber_id: null,
                model: {
                    username: '',
                    email: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    city: '',
                    country: '',
                    zipCode: '',
                    about: '',
                },
                sexes: [
                    { value: 'F', text: this.$i18n.t('message.female') },
                    { value: 'M', text: this.$i18n.t('message.male') }
                ],
                subscriber_id: JSON.parse(localStorage.getItem('user'))['slug'],
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled: {enabled: true},

                sort: {
                    enabled: true,
                    initialSortBy: {field: 'date', type: 'desc'}
                },
                affiliateColumns: [
                    {
                        label: this.$i18n.tc('message.produit', 1),
                        field: 'produit',
                    },                    
                    {
                        label: this.$i18n.tc('message.affilie', 1),
                        field: 'nom',
                    },
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                    {
                        field: 'qualite',
                        label: this.$i18n.t('message.lienParente')
                    },
                    {
                        field: 'date_fin',
                        label: this.$i18n.t('message.finAffiliation')
                    },
                    {
                        field: 'status_contrat',
                        label: this.$i18n.t('message.status')
                    },
                    {
                        field: 'actions',
                        label: 'Actions'
                    }
                ],
                patientColumns: [
                    {
                        label: this.$i18n.tc('message.produit', 1),
                        field: 'produit',
                    },                    
                    {
                        label: this.$i18n.tc('message.affilie', 1),
                        field: 'nom',
                    },
                   /*  {
                        field: 'dossier',
                        label: this.$i18n.t('message.fileNumber')
                    },
                    {
                        field: 'age',
                        label: this.$i18n.t('message.dob')
                    }, */
                    {
                        field: 'email',
                        label: this.$i18n.t('message.email')
                    },
                    {
                        field: 'qualite',
                        label: this.$i18n.t('message.lienParente')
                    }/* ,
                    {
                        field: 'date_debut',
                        label: this.$i18n.t('message.debutAffiliation')
                    } */,
                    {
                        field: 'date_fin',
                        label: this.$i18n.t('message.finAffiliation')
                    },
                    {
                        field: 'status_contrat',
                        label: this.$i18n.t('message.status')
                    },
                    {
                        field: 'actions',
                        label: 'Actions'
                    }
                ],
            }
        },

        methods: {
            handleView() {
                this.mobileView = window.innerWidth <= 990;
            },
            hasHistory () { return window.history.length > 2 },
            checkIfProfileComplete(){
                //this.$bvModal.show('modal-scoped');
                let user = JSON.parse(localStorage.getItem('user'));
                    if(user.souscripteur.sexe == ''){
                        //alert("Veuillez completer votre profile avant de continuer");
                        this.$bvModal.show('modal-scoped');
                     }
               
            },
            
            goToPaiement :function(){

               this.$router.push({ name: 'paiement', params: { identifiant: (JSON.parse(localStorage.getItem('user')))['slug'] } });

            },
            getAffiliations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit,
                    id:(JSON.parse(localStorage.getItem('user')))['id']
                };

                this.$store.dispatch('getAffiliationsSouscripteur', { args : args });
            },
            
            onaffiliateRowClick(params){
                    this.$router.push((this.$router.resolve({ name: 'affiliation',  params: { contrat: params.row.slug } })).href +  '#generale');
            },
            onaffiliateRowClickMobile(params){
                // console.log(params);
                    this.$router.push((this.$router.resolve({ name: 'affiliation',  params: { contrat: params } })).href +  '#generale');
            },
            onPaitientRowClick(params){
                // console.log(params.row.dossierSlug.slug+'-'+params.row.dossier)
                // console.log(params)
                   this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: params.row.dossierSlug.slug+'-'+params.row.dossier } })).href +  '#generale');

            },
            onPaitientRowClickMobile(params){
                // console.log(params.slug+'-'+params.dossier)
                   this.$router.push(  (this.$router.resolve({ name: 'medical-file',  params: { file: params.slug+'-'+params.dossier } })).href +  '#generale');

            },
           onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        subscriber: this.form.slug,
                        sexe: this.form.sexe,
                        nom: this.form.user.nom,
                        prenom: this.form.user.prenom,
                        telephone: this.form.user.telephone,
                        ville: this.form.user.ville,
                        pays: this.form.user.pays,
                    };

                    let successMessage = this.$i18n.t('message.subscriberUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateSubscriber', { args, errorMessages, successMessage }).then(() => {
                       this.$router.push({ name: 'add-patient-souscripteur', params: { } });
                    });
                }
            },
            getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },

            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
            getCountries: function() {
                let args = {};
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getCountries', { args, errorMessages });
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            getCommandes: function() {
                let args = {
                    souscripteur: (JSON.parse(localStorage.getItem('user')))['id']
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };
                this.$store.dispatch('getCommandes', { args, errorMessages });
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                user: {
                    nom: {
                        required
                    },
                    prenom: {
                        //
                    },
                    adresse: {
                        // required
                    },
                    telephone: {
                        required,
                        integer,
                        minLength: minLength(9)
                    },
                    email: {
                        required,
                        email
                    },
                    nationalite: {
                    },
                    ville: {
                        required
                    },
                    pays: {
                        required
                    },

                    quartier: {

                    },

                    code_postal: {

                    },
                },
                sexe: {
                    required
                },
                date_de_naissance: {
                    // required
                }
            }
        },
        created() {
            this.handleView();
            window.addEventListener('resize', this.handleView);
        },
        mounted() {
            this.checkIfProfileComplete();
            this.getSubscriber();
            this.getAffiliations();
        }

    }
</script>

<style>
.modal-backdrop {
  display: none !important;
}
#modal-scoped___BV_modal_backdrop_{
  display: none !important;
}
</style>